module.exports = __webpack_public_path__ + "5a9bd7225822886f3b844d911ca7abdb.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-21.png
 ** module id = 1012
 ** module chunks = 0
 **/